<template>
	<div>
		<div style="padding:20px;">
			<input type="file" id="uploads" accept="image" @change="upload" style="display:none;">
			<div class="show" style="background:url(/static/img/qua.png);background-size:100% 100%;">
				<div class="picture" onclick="uploads.click()" :style="'backgroundImage:url('+headerImage+')'"></div>
			</div>
			<div>
				<button @click="upload2">
					{{foodlist[LangID].on1}}
				</button>
			</div>
		</div>
		<div style="width:100%;height:7.5rem;">
			<vueCropper ref="cropper" v-if="ImageState" :img="option.img" :output-size="option.outputSize"
				:info="option.info" :can-scale="option.canScale" :auto-crop="option.autoCrop"
				:auto-crop-width="option.autoCropWidth" :auto-crop-height="option.autoCropHeight" :fixed="option.fixed"
				:fixed-number="option.fixedNumber" :full="option.full" :fixed-box="option.fixedBox"
				:can-move="option.canMove" :can-move-box="option.canMoveBox" :original="option.original"
				:center-box="option.centerBox" :height="option.height" :info-true="option.infoTrue"
				:max-img-size="option.maxImgSize" :enlarge="option.enlarge" :mode="option.mode"
				:limit-min-size="option.limitMinSize" @realTime="realTime"></vueCropper>
		</div>
		<div class="toast" v-show="toastShow">{{toastText}}</div>
	</div>
</template>

<script>
	import Exif from 'exif-js'
	import '../../static/js/rem.js'
	/*import {
		VueCropper
	} from 'vue-cropper'*/
	import VueCropper from '../../comm/vue-cropper'
	export default {
		data() {
			return {
				headerImage: '',
				picValue: '',
				ImageState: false,
				toastShow: false,
				toastText:"",
				LangID:0,
				foodlist:[
					{on1:"提交图片",on2:"请上传图片",on3:"上传成功",on4:"拉花图片已上传！"},
					{on1:"提交图片",on2:"请上传图片",on3:"上传成功",on4:"拉花图片已上传！"},
					{on1: "Submit image", on2: "Please upload an image", on3: "Upload Successful",on4: "The floral image has been uploaded! "},
					{on1: "Submit image", on2: "Please upload an image", on3: "Upload Successful",on4: "The floral image has been uploaded! "},
					{on1: "Submit image", on2: "Please upload an image", on3: "Upload Successful",on4: "The floral image has been uploaded! "},
					{on1: "Submit image", on2: "Please upload an image", on3: "Upload Successful",on4: "The floral image has been uploaded! "},
					{on1: "Submit image", on2: "Please upload an image", on3: "Upload Successful",on4: "The floral image has been uploaded! "},
					{on1: "Submit image", on2: "Please upload an image", on3: "Upload Successful",on4: "The floral image has been uploaded! "},
					{on1: "Submit image", on2: "Please upload an image", on3: "Upload Successful",on4: "The floral image has been uploaded! "},
					{on1: "Submit image", on2: "Please upload an image", on3: "Upload Successful",on4: "The floral image has been uploaded! "},
					{on1: "Submit image", on2: "Please upload an image", on3: "Upload Successful",on4: "The floral image has been uploaded! "},
					{on1: "Submit image", on2: "Please upload an image", on3: "Upload Successful",on4: "The floral image has been uploaded! "},
					{on1: "Submit image", on2: "Please upload an image", on3: "Upload Successful",on4: "The floral image has been uploaded! "},
					{on1: "Submit image", on2: "Please upload an image", on3: "Upload Successful",on4: "The floral image has been uploaded! "},
					{on1: "Submit image", on2: "Please upload an image", on3: "Upload Successful",on4: "The floral image has been uploaded! "},
					{on1: "Submit image", on2: "Please upload an image", on3: "Upload Successful",on4: "The floral image has been uploaded! "},
					{on1: "Submit image", on2: "Please upload an image", on3: "Upload Successful",on4: "The floral image has been uploaded! "},
					{on1: "Submit image", on2: "Please upload an image", on3: "Upload Successful",on4: "The floral image has been uploaded! "},
					{on1: "Submit image", on2: "Please upload an image", on3: "Upload Successful",on4: "The floral image has been uploaded! "},
					{on1: "Submit image", on2: "Please upload an image", on3: "Upload Successful",on4: "The floral image has been uploaded! "},
					{on1: "Submit image", on2: "Please upload an image", on3: "Upload Successful",on4: "The floral image has been uploaded! "},
					{on1: "Submit image", on2: "Please upload an image", on3: "Upload Successful",on4: "The floral image has been uploaded! "},
					{on1: "Submit image", on2: "Please upload an image", on3: "Upload Successful",on4: "The floral image has been uploaded! "},
					{on1: "Submit image", on2: "Please upload an image", on3: "Upload Successful",on4: "The floral image has been uploaded! "},
					{on1: "Submit image", on2: "Please upload an image", on3: "Upload Successful",on4: "The floral image has been uploaded! "},
					{on1: "Submit image", on2: "Please upload an image", on3: "Upload Successful",on4: "The floral image has been uploaded! "},
					{on1: "Submit image", on2: "Please upload an image", on3: "Upload Successful",on4: "The floral image has been uploaded! "},
					{on1: "Submit image", on2: "Please upload an image", on3: "Upload Successful",on4: "The floral image has been uploaded! "},
					{on1:"Submit image",on2:"Please upload an image",on3:"Upload Successful",on4:"The floral image has been uploaded! "},
					{on1:"Submit image",on2:"Please upload an image",on3:"Upload Successful",on4:"The floral image has been uploaded! "},
					{on1:"Submit image",on2:"Please upload an image",on3:"Upload Successful",on4:"The floral image has been uploaded! "},
					{on1:"Submit image",on2:"Please upload an image",on3:"Upload Successful",on4:"The floral image has been uploaded! "},
					{on1:"Зураг илгээх",on2:"Зураг байршуулна уу",on3:"Байршуулалт амжилттай",on4:"Зураг байршуулсан!"},
				],
				option: {
					img: '', // 裁剪图片的地址
					outputSize: 1, // 裁剪生成图片的质量(可选0.1 - 1)
					outputType: 'png', // 裁剪生成图片的格式（png || png || webp），使用PNG保持质量
					info: false, // 图片大小信息
					canScale: false, // 图片是否允许滚轮缩放
					autoCrop: true, // 是否默认生成截图框
					autoCropWidth: 0, // 默认生成截图框宽度（设为0，将根据图片宽度自动计算）
					autoCropHeight: 0, // 默认生成截图框高度（设为0，将根据图片宽度和比例自动计算）
					fixed: true, // 是否开启截图框宽高固定比例
					fixedNumber: [1, 1], // 截图框的宽高比例改为1.5:1
					full: false, // false按原比例裁切图片，不失真
					fixedBox: false, // 允许调整截图框大小
					canMove: true, // 上传图片是否可以移动
					canMoveBox: true, // 截图框能否拖动
					original: false, // 上传图片不按照原始比例渲染，进行缩放
					centerBox: true, // 截图框是否被限制在图片里面
					height: true, // 是否按照设备的dpr 输出等比例图片
					infoTrue: true, // true为展示真实输出图片宽高，false展示看到的截图框宽高
					maxImgSize: 1000, // 限制图片最大宽度和高度
					enlarge: 2, // 图片根据截图框输出比例倍数
					mode: 'contain', // 图片默认渲染方式，让图片缩放以完全显示在裁剪区域内
				}
			}
		},
		components: {
			VueCropper
		},
		mounted() {
			this.LangID=this.$route.query.LangID
		},
		methods: {
			toast(str) {
				let v = this
				v.toastText = str
				v.toastShow = true
				setTimeout(function() {
					v.toastShow = false
				}, 2500)
			},
			realTime(sb) {
				var that = this
				that.$refs.cropper.getCropData(data => {
					that.headerImage = data
				})
			},
			upload2() {
				if (this.headerImage == "") {
					this.toast(this.foodlist[this.LangID].on2)
					return
				}
				var id = this.$route.query.ArtID
				var that = this
				that.$refs.cropper.getCropData(data => {
					var sj = {
						base64String: data,
						laFlowerID: id
					}
					var url = "http://milkteaapi.hhlsoft.cn/UploadLatteArtImg/UploadLaFlowerPic"//国内
					//var url = "http://milkteaapi.hlwxsys.com/UploadLatteArtImg/UploadLaFlowerPic"//新加坡
					that.axios.post(url, sj).then((res) => {
						console.log(res)
						if(res.data.result){
							that.ImageState = false
							that.toast(that.foodlist[that.LangID].on3)
						}else{
							that.ImageState = false
							that.toast(that.foodlist[that.LangID].on4)
						}
					})
				})
			},
			upload(e) {
				let files = e.target.files || e.dataTransfer.files;
				if (!files.length) return;
				this.picValue = files[0];
				this.imgPreview(this.picValue);
			},
			imgPreview(file) {
				let self = this;
				let Orientation;
				//去获取拍照时的信息，解决拍出来的照片旋转问题  
				Exif.getData(file, function() {
					//Orientation = Exif.getTag(this, 'Orientation');
				});
				// 看支持不支持FileReader  
				if (!file || !window.FileReader) return;

				if (/^image/.test(file.type)) {
					// 创建一个reader  
					let reader = new FileReader();
					// 将图片2将转成 base64 格式  
					reader.readAsDataURL(file);
					// 读取成功后的回调  
					reader.onloadend = function() {
						console.log(this)
						console.log(this.result)
						let result = this.result;
						let img = new Image();
						img.src = result;
						//判断图片是否大于100K,是就直接上传，反之压缩图片  
						self.headerImage = this.result;
						self.option.img = this.result;
						self.ImageState = true
					}
				}
			},
			rotateImg(img, direction, canvas) {
				//最小与最大旋转方向，图片旋转4次后回到原方向      
				const min_step = 0;
				const max_step = 3;
				if (img == null) return;
				//img的高度和宽度不能在img元素隐藏后获取，否则会出错      
				let height = img.height;
				let width = img.width;
				let step = 2;
				if (step == null) {
					step = min_step;
				}
				if (direction == 'right') {
					step++;
					//旋转到原位置，即超过最大值      
					step > max_step && (step = min_step);
				} else {
					step--;
					step < min_step && (step = max_step);
				}
				//旋转角度以弧度值为参数      
				let degree = step * 90 * Math.PI / 180;
				let ctx = canvas.getContext('2d');
				switch (step) {
					case 0:
						canvas.width = width;
						canvas.height = height;
						ctx.drawImage(img, 0, 0);
						break;
					case 1:
						canvas.width = height;
						canvas.height = width;
						ctx.rotate(degree);
						ctx.drawImage(img, 0, -height);
						break;
					case 2:
						canvas.width = width;
						canvas.height = height;
						ctx.rotate(degree);
						ctx.drawImage(img, -width, -height);
						break;
					case 3:
						canvas.width = height;
						canvas.height = width;
						ctx.rotate(degree);
						ctx.drawImage(img, -width, 0);
						break;
				}
			},
		}
	}
</script>

<style>
	* {
		margin: 0;
		padding: 0;
	}

	.show {
		margin: 0 auto;
		width: 3.5rem;
		height: 3.5rem;
		overflow: hidden;
		position: relative;
		border-radius: 50%;
		border: 1px solid #d5d5d5;
	}

	.picture {
		width: 100%;
		height: 100%;
		overflow: hidden;
		background-position: center center;
		background-repeat: no-repeat;
		background-size: cover;
	}

	.toast {
		position: fixed;
		z-index: 2000;
		left: 50%;
		top: 45%;
		transition: all 5s;
		-webkit-transform: translateX(-50%) translateY(-50%);
		-moz-transform: translateX(-50%) translateY(-50%);
		-ms-transform: translateX(-50%) translateY(-50%);
		-o-transform: translateX(-50%) translateY(-50%);
		transform: translateX(-50%) translateY(-50%);
		text-align: center;
		border-radius: 5px;
		color: #FFF;
		background: rgba(17, 17, 17, 0.7);
		height: 1rem;
		padding: 0 15px;
		font-size: .3rem;
		display: flex;
		align-items: center;
		justify-content: space-around;
	}
</style>



// WEBPACK FOOTER //
// src/components/index6.vue